module.exports = __webpack_public_path__ + "static/IBMPlexSans-Italic-d46b88b2cb1e778997c2b6c9b43fffd0.woff";